export default __webpack_public_path__ + "static/media/whatsapp-free-trial-banner.00457ec0.png";